// extracted by mini-css-extract-plugin
export default {"CommentsButton":"il_a bht_wx bht_jb bht_xl bht_i bht_j bht_q bht_vt bht_et bht_so bht_sp bht_eg","CommentsButton__icon":"il_b bht_rz"};